import React from "react"
import "./index.css"
import Home from "./Components/Home"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Calculater1 from "./Components/Calculater1"
import Calculater2 from "./Components/Calculater2"
import Calculater3 from "./Components/Calculater3"
import Calculater from "./Components/Calculater"

// import Calculater2 from "./Components/Calculater2"

const App=()=>{
  document.title=" All in one Calculator"
  return(
    <>
<BrowserRouter>
  <Routes>
    <Route path="/" element={<Home/>}></Route>
    <Route path="/bmicalculator" element={<Calculater1/>}></Route>
    <Route path="/sicalculator" element={<Calculater2/>}></Route>
    <Route path="/cicalculator" element={<Calculater3/>}></Route>
    <Route path="/calculator" element={<Calculater/>}></Route>
  </Routes>
</BrowserRouter>
    </>
  )
}
export default App